import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import { USERS_LIST_QUERY_KEY, USER_DETAIL_QUERY_KEY } from "./constants";

async function deleteUser(id: string): Promise<void> {
  // 204 No Content on success — `httpClient` returns `null` for those,
  // and we just discard it since the caller is interested in the
  // side-effect, not a payload.
  await httpClient<null>(`/api/admin/users/${encodeURIComponent(id)}`, {
    method: "DELETE",
  });
}

export function useDeleteUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteUser,
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({ queryKey: USERS_LIST_QUERY_KEY });
      queryClient.removeQueries({ queryKey: [...USER_DETAIL_QUERY_KEY, id] });
    },
  });
}
